import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IonicService {
  keyboardOpen = signal(false);
  keyboardHeight = signal(0);

  constructor() {}
}
